import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ServiceSelector } from './ServiceSelector/ServiceSelector';
import { DateSelector } from './DateSelector/DateSelector';
import { DoctorSelector } from './DoctorSelector/DoctorSelector';
import { ChildServiceSelector } from './ServiceSelector/ChildServiceSelector/ChildServiceSelector';
import {
    selectBranch,
    selectChildrenFlag,
    selectDirection,
    selectDoctor,
    selectService,
    selectSubGroup,
} from '../store/serviceSlice';
import { ServiceBookingContainer } from '../ServiceBookingContainer';
import {
    getChildrenState,
    getHasChildServices,
    getSelectedService,
    getServiceFilterServices,
    getSpecialtyFilterDirections,
} from '../store/selectors';
import { DoctorList } from './DoctorList/DoctorList';
import { useWidgetProps } from '../../WidgetPropsContext';
import { getSelectedItemIdByName } from '../util/service';

export const ServiceBookingForm = () => {
    const {
        serviceId, specialtyId, categoryId, serviceBranchId, serviceDoctorId, serviceName, specialtyName,
    } = useWidgetProps();
    const { forChild, childrenAge } = useSelector(getChildrenState);
    const hasChildServices = useSelector(getHasChildServices);
    const servicesFromFilter = useSelector(getServiceFilterServices);
    const specialityesFromFilter = useSelector(getSpecialtyFilterDirections);
    const [ isServiceSet, setIsServiceSet ] = useState();
    const [ isBranchSet, setIsBranchSet ] = useState();

    const services = useSelector(getSelectedService);
    const dispatch = useDispatch();
    const childServiceSelectorHandler = (child, age) => {
        dispatch(
            selectChildrenFlag({
                forChild: child,
                childrenAge: age,
            }),
        );
    };

    useEffect(() => {
        // eslint-disable-next-line no-undef
        window?.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (
            specialtyId &&
            (services?.selected?.directions === undefined || services?.selected?.directions === null) &&
            services.isDataLoaded
        ) {
            dispatch(selectDirection(specialtyId));
        }
    }, [ specialtyId, services?.isDataLoaded ]);

    useEffect(() => {
        if (
            specialtyName &&
            (services?.selected?.directions === undefined || services?.selected?.directions === null) &&
            services.isDataLoaded
        ) {
            const specialtyIdByName = getSelectedItemIdByName(specialityesFromFilter, specialtyName);
            if (specialtyIdByName) {
                dispatch(selectDirection(specialtyIdByName));
            }
        }
    }, [ specialtyName, services?.isDataLoaded ]);

    useEffect(() => {
        if (
            categoryId &&
            (services?.selected?.subGroups === undefined || services?.selected?.subGroups === null) &&
            services?.isDataLoaded
        ) {
            dispatch(selectSubGroup(categoryId));
        }
    }, [ categoryId, services?.isDataLoaded ]);

    useEffect(() => {
        if (
            serviceId &&
            (services?.selected?.services === undefined || services?.selected?.services === null) &&
            services?.isDataLoaded
        ) {
            dispatch(selectService(serviceId));
            setIsServiceSet(true);
        }
    }, [ serviceId, services?.isDataLoaded ]);

    useEffect(() => {
        if (
            serviceName &&
            (services?.selected?.services === undefined || services?.selected?.services === null) &&
            services?.isDataLoaded && servicesFromFilter
        ) {
            const serviceIdByName = getSelectedItemIdByName(servicesFromFilter, serviceName);
            if (serviceIdByName) {
                dispatch(selectService(serviceIdByName));
                setIsServiceSet(true);
            }
            // dispatch(selectService(serviceId));
            // setIsServiceSet(true);
        }
    }, [ serviceName, services?.isDataLoaded ]);

    /*
    Two separate useEffect hooks are used to ensure that the timeslot fetch runs only after branchId is selected.
    Otherwise, a bug occurs where the doctor is preselected but doesn't appear in the list below the calendar. */

    useEffect(() => {
        if (
            serviceId &&
            serviceBranchId &&
            isServiceSet &&
            (services?.selected?.branches === undefined || services?.selected?.branches === null) &&
            services?.isDataLoaded
        ) {
            dispatch(selectBranch(serviceBranchId));
            setIsBranchSet(true);
        }
    }, [ serviceId, serviceBranchId, isServiceSet, services?.isDataLoaded ]); // Use isServiceSet instead of depending on services.services to avoid re-selection after clearing filters

    useEffect(() => {
        if (
            serviceId &&
            serviceBranchId &&
            serviceDoctorId &&
            isBranchSet &&
            (services?.selected?.doctors === undefined || services?.selected?.doctors === null) &&
            services?.isDataLoaded
        ) {
            dispatch(selectDoctor(serviceDoctorId));
        }
    }, [ serviceId, serviceBranchId, serviceDoctorId, isBranchSet, services?.isDataLoaded ]); // Use isBranchSet instead of depending on services.branches to avoid re-selection after clearing filters

    return (
        <>
            <ServiceBookingContainer/>
            {hasChildServices && (
                <ChildServiceSelector forChild={forChild} childrenAge={childrenAge} onSelect={childServiceSelectorHandler}/>
            )}
            <ServiceSelector services={services}/>
            {services?.selected?.branches && services?.selected?.services && <DoctorSelector/>}
            {services?.selected?.branches && services?.selected?.services && <DateSelector/>}
            {services?.selected?.branches && services?.selected?.services && <DoctorList/>}
        </>
    );
};
